import Logger from "./logger";

export default class AddressDelete {
	private buttonElement: HTMLButtonElement;
	private addressEndpoint: string;
	private confirmQuestion = 'Are you sure you want to delete this address? This cannot be undone.'; 

	constructor(element: HTMLButtonElement) {
		this.buttonElement = element;
		if (!this.buttonElement) return;
		this.addressEndpoint = this.buttonElement.getAttribute('data-delete-address-endpoint') || '';
		this.attachDeleteEvent();
	}

	private attachDeleteEvent() {
		this.buttonElement.addEventListener('click', (e) => this.handleDeleteClick(e));
	}

	private async handleDeleteClick(e: Event) {
		e.preventDefault();
		const confirmDialog = document.querySelector('.js-global-confirm-dialog') as any;
		if (!confirmDialog) {
			// fallback to native confirm if dialog is missing
			if (!window.confirm(this.confirmQuestion)) return;
		} else {
			const confirmed = await confirmDialog.show(this.confirmQuestion);
			if (!confirmed) return;
		}
		fetch(this.addressEndpoint, {
			method: 'DELETE',
			headers: {
				'Content-Type': 'application/json'
			}
		})
			.then(response => {
				if (response.ok) {
					window.location.reload();
				} else {
					this.setDeleteMessage('Failed to delete address.');
				}
			})
			.catch(error => {
				Logger.trackException(error, 'Unknown error deleting address in your account.');
				this.setDeleteMessage('An error occurred while trying to delete the address.');
			});
	}

	private setDeleteMessage(message: string) {
		const deleteMessageElement = document.querySelector('.js-delete-address-error') as HTMLElement;
		if (deleteMessageElement) {
			deleteMessageElement.innerHTML = `
			<p class="formError" data-test="form-error-message"><span>${message}</span></p>
		`;
		}
	}
}
